module.exports = require('./lib/toArray.js').default;